module.exports = __webpack_public_path__ + "img/gtzy1_zhCn-.e6ab3ed4.png";